var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404S(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 726,
    height: 276,
    viewBox: "0 0 726 276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "tyica",
    d: "M981.7 531.8v-97.6l-60.8 97.6zm-261.2 114c-78 0-114.4-67.6-114.4-138s36.4-137.6 114.4-137.6 114.4 67.2 114.4 137.6c0 70.4-36.4 138-114.4 138zm0-60.8c32 0 44.8-30 44.8-77.2S752.5 431 720.5 431c-32 0-44.8 29.6-44.8 76.8 0 47.2 12.8 77.2 44.8 77.2zm330.4 56h-69.2v-48.8H854.1v-53.6l101.2-164.4h95.6v157.6h32.4v60.4h-32.4zM485.7 531.8v-97.6l-60.8 97.6zM554.9 641h-69.2v-48.8H358.1v-53.6l101.2-164.4h95.6v157.6h32.4v60.4h-32.4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-358 -370)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#tyica"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404S);
export default __webpack_public_path__ + "static/media/404_s.52bde15bfa660f3471c1651e4d556e3c.svg";
export { ForwardRef as ReactComponent };